export const grey = {
  borderColor: "rgb(181,181,181)",
  backgroundColor: "rgba(139, 139, 141, .5)",
  borderWidth: 1,
};

export const greyLight = {
  borderColor: "rgb(169,222,222)",
  backgroundColor: "rgba(154,194,194,0.5)",
  borderWidth: 1,
};

export const greyDark = {
  borderColor: "rgb(122,121,121)",
  backgroundColor: "rgba(75,75,75,0.5)",
  borderWidth: 1,
};

export const yellow = {
  borderColor: "rgba(248, 185, 23, 1)",
  backgroundColor: "rgba(248, 185, 23, .5)",
  borderWidth: 1,
};

export const red = {
  borderColor: "rgba(255, 64, 64, 1)",
  backgroundColor: "rgba(255, 64, 64, .5)",
  borderWidth: 1,
};

export const green = {
  borderColor: "rgba(98, 218, 151, 1)",
  backgroundColor: "rgba(98, 218, 151, .5)",
  borderWidth: 1,
};

export const blue = {
  backgroundColor: "rgba(21, 123, 250, .5)",
  borderColor: "rgba(21, 123, 250, 1)",
  borderWidth: 1,
};

export const violet = {
  backgroundColor: "rgba(193, 55, 189, .5)",
  borderColor: "rgba(193, 55, 189)",
  borderWidth: 1,
};

export const blueLight = {
  backgroundColor: "rgba(79, 195, 247, .5)",
  borderColor: "rgba(79, 195, 247, 1)",
  borderWidth: 1,
};

export const blueGreen = {
  backgroundColor: "rgba(65, 170, 196, .5)",
  borderColor: "rgba(65, 170, 196, 1)",
  borderWidth: 1,
};

export const greenDark = {
  backgroundColor: "rgba(128, 203, 196, .5)",
  borderColor: "rgba(128, 203, 196, 1)",
  borderWidth: 1,
};

export const orange = {
  backgroundColor: "rgba(255, 152, 0, .5)",
  borderColor: "rgba(255, 152, 0, 1)",
  borderWidth: 1,
};

export const orange2 = {
  backgroundColor: "rgba(210, 166, 24, .5)",
  borderColor: "rgba(210, 166, 24, 1)",
  borderWidth: 1,
};

export const orange3 = {
  backgroundColor: "rgba(199, 157, 23, .5)",
  borderColor: "rgba(199, 157, 23, 1)",
  borderWidth: 1,
};

export const orange4 = {
  backgroundColor: "rgba(189, 149, 22, .5)",
  borderColor: "rgba(189, 149, 22, 1)",
  borderWidth: 1,
};

export const orange5 = {
  backgroundColor: "rgba(178, 141, 19, .5)",
  borderColor: "rgba(178, 141, 19, 1)",
  borderWidth: 1,
};

export const sun = {
  backgroundColor: "rgba(242, 210, 16, .5)",
  borderColor: "rgba(242, 210, 16, 1)",
  borderWidth: 1,
};

export default {
  grey,
  greyLight,
  greyDark,
  gray: grey,
  yellow,
  red,
  green,
  blue,
  violet,
  blueLight,
  blueGreen,
  greenDark,
  orange,
  orange2,
  orange3,
  orange4,
  orange5,
  sun,
};



// WEBPACK FOOTER //
// ./src/containers/DocumentManagementDashboard/colors.js